import { render, staticRenderFns } from "./maintenanceObjCheck.vue?vue&type=template&id=6c473a90"
import script from "./maintenanceObjCheck.vue?vue&type=script&lang=js"
export * from "./maintenanceObjCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports